import type { Observable } from 'rxjs';
import type { AdminTeammatesPage } from './admin-teammates.page';

/**
 * Blocks navigation away from the Teammates page while the Builder holds unsaved
 * work, so browser Back (or sidebar nav) can't silently discard it. Delegates the
 * decision to the page component. The Builder lands in SB-3200 split b; until then
 * `canDeactivate()` always allows navigation.
 *
 * Angular passes `null` as the component when the instance is not available at
 * guard-run time (destroyed / never fully activated during a racing
 * re-navigation) — nothing to deactivate, so allow navigation.
 * (Guards against the same crash as SQUADBOX-CR.)
 */
export const adminTeammatesCanDeactivateGuard = (
  component: AdminTeammatesPage | null,
): Observable<boolean> | boolean =>
  component ? component.canDeactivate() : true;
